import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';
import { FormModalComponent } from '../form-modal/form-modal.component';
import Masonry from 'masonry-layout';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
	selector      : 'app-convenor',
	templateUrl   : './convenor.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class ConvenorComponent implements OnInit {
	@Input() convenorWpData     : any;
	@Input() convenorDotNetData : any;
	public action : any = 'listing';
	public isMobile : boolean;

	constructor(
		private modalService : NgbModal,
		public shareddata    : Shareddata,
		private funcs          : FuncsService,
	) {
		smoothscroll.polyfill();
		this.isMobile = this.funcs.globalDetectDevice();
		this.funcs.globalLocalStorageHttp();
		var userData = this.funcs.globalSetUserSession();
		if ( userData )
			this.shareddata.setUserSession( userData );
		setTimeout ( () => {
			this.ngAfterViewInit();
		}, 900 );
	}

	ngOnInit() {}

	openFormModal( form_title, form_content, user_org ) {
		const modalRef = this.modalService.open(
			FormModalComponent,
			{
				size: 'lg',
				windowClass: 'custom-modal',
				backdrop  : 'static',
				keyboard  : false,
			}
		);
		modalRef.componentInstance.form_title = form_title;
		modalRef.componentInstance.form_content = form_content;
	}

	ngAfterViewInit() {
		if ( false === this.isMobile) {
			setTimeout (
				() => {
					if ( document.querySelector( '.convenor-grid' ) )
						this.addMasonry( 'afterview' );
				}, 300
			);
		}
		if ( ! document.querySelector( 'body' ).classList.contains( 'body-community-page' ) )
			document.querySelector( 'body' ).classList.add( 'body-community-page' )
	}

	onResize( event ) {
		if ( document.querySelector( '.convenor-grid' ) )
			this.addMasonry( 'resize' );
	}

	addMasonry( type ) {
		var convElem = document.querySelector( '.convenor-grid' );
		var convElemmsnry = new Masonry( convElem, {
			itemSelector: '.convenor-grid-item',
			columnWidth: '.grid-sizer-2',
			percentPosition: true,
		});
		if( 'afterview' == type ) {
			convElemmsnry.on( 'layoutComplete', ()=> {
				convElemmsnry.layout();
			});
		}
	}

	fix_url( $url ) {
		if ( $url.includes( 'http' ) || $url.includes( 'https' ) )
			$url = $url;
		else
			$url = 'http://' + $url;
        return $url;
	}
}